import { useAtomValue } from 'jotai';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';

/**
 * Whether a collection can be made internal only from the collection modals.
 *
 * Only gates the setting: collections that already are internal only are shown
 * as such, and kept out of the help center pickers, either way.
 */
export function useShowInternalOnlyCollections(): boolean {
  const { featureFlags } = useAtomValue(featureFlagsAtom);

  return featureFlags.internalOnlyCollections;
}
